import { useCurrentOrganization } from "@src/modules/member/hooks/organizations";
import { OrganizationRole } from "@src/modules/member/models/organization";
import { createContext, useMemo } from "react";

export interface PermissionContextValue {
  permissions: string[];
  role: OrganizationRole | null;
}

export const PermissionContext = createContext<PermissionContextValue>({
  permissions: [],
  role: null,
});

export default function PermissionContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const organization = useCurrentOrganization();

  const contextValue = useMemo<PermissionContextValue>(() => {
    if (!organization?.role) {
      return { permissions: [], role: null };
    }

    return {
      permissions: organization.role.permissions ?? [],
      role: organization.role,
    };
  }, [organization?.role]);

  return (
    <PermissionContext.Provider value={contextValue}>
      {children}
    </PermissionContext.Provider>
  );
}
